import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/cluster/importer/clusterImporterActions';

export default importerReducers(actions);
